// extracted by mini-css-extract-plugin
export default {"container":"TeamCard_container__rKDuq","overlay":"TeamCard_overlay__9o+sk","socialDiv":"TeamCard_socialDiv__csQN6"};